import React, {
    useContext,
} from 'react';
import { useNavigate, useParams } from "react-router";
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from '../router'

import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';

export default function BestAvailableButton(props) {

    const {notification, setNotification} = useContext(NotificationContext);
    const { instanceId } = useParams();
    let navigate = useNavigate();

    const addBestAvailable = useMutation({
        mutationFn: () => QUERIES.addBestAvailable(props.ticketQuantity),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchBasketData();
            navigate(`/book-online/${instanceId}/edit-tickets`);
        },
    })

    return (
        <button className='btn btn--primary' 
                type="button" 
                onClick={() => addBestAvailable.mutateAsync()}
                disabled={addBestAvailable.isPending}>
            Choose best available
            {addBestAvailable.isPending &&
                <LoadingIndicator />
            }
        </button>
    );
}